import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { 
  Globe, 
  CheckCircle, 
  Home,
  LogIn
} from "lucide-react";

const SignedOutPage = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Simple Navigation */}
      <nav className="bg-white/90 backdrop-blur-xl border-b border-border">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Globe className="w-6 h-6 text-primary" />
            <span className="font-heading text-xl font-bold tracking-tight text-foreground">MeteoTranslate</span>
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-emerald-600" />
          </div>
          
          <h1 className="text-3xl font-bold text-foreground mb-3">
            Signed Out Successfully
          </h1>
          
          <p className="text-muted-foreground mb-8">
            You have been securely signed out of your MeteoTranslate account. 
            Thank you for using our meteorological translation services.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button className="bg-primary hover:bg-primary-hover text-white w-full sm:w-auto">
                <Home className="w-4 h-4 mr-2" />
                Go to Home Page
              </Button>
            </Link>
            <Link to="/" state={{ openAuth: true }}>
              <Button variant="outline" className="border-border w-full sm:w-auto">
                <LogIn className="w-4 h-4 mr-2" />
                Sign In Again
              </Button>
            </Link>
          </div>

          <div className="mt-12 pt-8 border-t border-border">
            <p className="text-xs text-muted-foreground">
              Powered by <span className="font-semibold">ALTAM™ Operating Software</span>, a Pecaro product
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignedOutPage;
